import {CellBuilderDate, CellBuilderFlagIcon, CellBuilderIconLabel, CellBuilderLabel, CellBuilderString, GridDataRowJson} from "back/commons/widgets/grid-libs";
import {IColSearchBuilder, ISearchFunc} from "lib/wsp/search";
import {IWspEnv, Wsp} from "lib/wsp/wsp";
import {IGridDataRow, IRowSortFn} from "back/commons/widgets/grid-core";
import {ESrcField, JSrcFields, RESPS, SRC, srcRef, srcUri} from "lib/wsp/src";
import {POPUP, PopupTooltip} from "back/commons/widgets/popups";
import {IView} from "lib/commons/views";
import {SRCDRAWER, SrcDrawer} from "back/wsp/widgets/srcDrawer";
import {IReg, REG} from "lib/commons/registry";
import {DOM} from "lib/commons/xml/dom";
import {ISrcRenderer, ITEM} from "lib/wsp/item";
import {ILcProvider, ItemTypeTask, WspMetaUi} from "lib/wsp/wspMetaUi";
import {EFolderState, GridDataRowJsonTree} from "back/commons/widgets/tree";
import {CellBuilderAccount, CellBuilderAccounts} from "back/core/widgets/usersGrid";
import {ICoreUniverseEnv} from "lib/core/universe";


export class CellBuilderSrcIconCode extends CellBuilderIconLabel implements IColSearchBuilder {

	protected srcRdr: ISrcRenderer;

	constructor(reg: IReg<any>, public wspMetaUi: WspMetaUi, public noTooltip?: boolean, public sortFn: (a: srcUri, b: srcUri) => number = SRC.sortSrcUriTree) {
		super(null);
		this.srcRdr = reg.getSvc(ITEM.KEY_SrcRenderer);
		this.iconFilter = "var(--filter)";
	}

	protected _getValue(row: GridDataRowJson<JSrcFields>): string {
		return row.cacheHolder['code'] || (row.cacheHolder['code'] = this.srcRdr.getMainName(row.rowDatas, this.wspMetaUi));
	}

	protected _getIcon(row: GridDataRowJson<JSrcFields>): string {
		if (row instanceof GridDataRowJsonTree && row.getFolderState() === EFolderState.opened) return row.cacheHolder['iconOpen'] || (row.cacheHolder['iconOpen'] = this.srcRdr.getIcon(row.rowDatas, this.wspMetaUi, true));
		return row.cacheHolder['icon'] || (row.cacheHolder['icon'] = this.srcRdr.getIcon(row.rowDatas, this.wspMetaUi));
	}

	redrawCell(row: GridDataRowJson<JSrcFields>, root: HTMLElement): void {
		(root as JSrcFieldsPointer)._srcFields = row.rowDatas;
		//if( isTooltipPointer(root)) root.popupTooltip.contentRoot
		super.redrawCell(row, root);
	}

	protected _buildContent(row: IGridDataRow, root: HTMLElement): HTMLElement {
		if (!this.noTooltip) this._addTooltip(root);
		return super._buildContent(row, root);
	}

	protected _addTooltip(root: HTMLElement & JSrcFieldsPointer) {
		//On remonte sur la cell pour que le positionnement du tooltip reste dans la zone du grid.
		const cell = DOM.findParentOrSelf(root, null, (n): n is HTMLElement => n instanceof Element && n.classList.contains("cell")) || root;
		POPUP.promiseTooltip(cell,
			(owner: HTMLElement, tooltip: PopupTooltip): IView | null => {
				tooltip.addEventListener('c-show', function (this: PopupTooltip, ev: CustomEvent) {
					const srcFields = root._srcFields;
					if (srcFields) (this.view as SrcDrawer).setSrcRef(SRC.srcRef(srcFields), srcFields);
					else ev.preventDefault();
				});
				return new SrcDrawer().initialize({skin: 'wsp-src-drawer/tooltip', tpl: SRCDRAWER.detailsPreviewTpl, reg: REG.findReg(owner) as IReg<IWspEnv>});
			},
			{
				hoverAllowed: true, anchor: {
					posFrom: root, intersectWith: cell, fromX: 'end', marginX: -3,
					notAvailableSpace: {
						posFrom: root, intersectWith: cell, fromX: 'end', targetX: 'end', fromY:'bottom', marginY: -3
					}
				}
			}
		);
	}

	getColSortFn(): IRowSortFn {
		return (r1: GridDataRowJson<JSrcFields>, r2: GridDataRowJson<JSrcFields>) => {
			const v1 = this._getValue(r1);
			const v2 = this._getValue(r2);
			if (v1 == null) {
				if (v2 == null) return 0;
				return 1;
			} else if (v2 == null) return -1;
			return this.sortFn(v1, v2);
		}
	}

	fillSearchColumns(map: Map<string, string | ISearchFunc>) {
		map.set('srcUri', null);
		map.set('itModel', null);
	}
}

export interface JSrcFieldsPointer {
	_srcFields?: JSrcFields
}

/**
 *
 */
export class CellBuilderSrcIconCodeTitle extends CellBuilderSrcIconCode {

	redrawCell(row: GridDataRowJson<JSrcFields>, root: HTMLElement): void {
		(root as JSrcFieldsPointer)._srcFields = row.rowDatas;
		let span = root.firstElementChild as HTMLElement;
		if (!span) span = this._buildContent(row, root);
		this.redrawIcon(row, span);
		span = span.nextElementSibling as HTMLElement;
		DOM.setTextContent(span, this._getValue(row));
		span = span.nextElementSibling as HTMLElement;
		DOM.setTextContent(span, this._getTitle(row));
	}


	protected _buildContent(row: IGridDataRow, root: HTMLElement): HTMLElement {
		//icon
		const spanIcon = super._buildContent(row, root);
		//code
		root.appendChild(document.createElement('span'));
		//title
		const st = root.appendChild(document.createElement('span')).style;
		st.color = "var(--alt1-color)";
		st.fontStyle = "italic";
		st.marginInlineStart = this.iconLabelGap;
		return spanIcon;
	}

	protected _getTitle(row: GridDataRowJson<JSrcFields>) {
		return this.srcRdr.getSecondName(row.rowDatas, this.wspMetaUi) || "";
	}

	fillSearchColumns(map: Map<string, string | ISearchFunc>) {
		super.fillSearchColumns(map);
		map.set('itTi', null);
	}

}

/**
 *
 */
export class CellBuilderSrcIconTitle extends CellBuilderSrcIconCode {

	redrawCell(row: GridDataRowJson<JSrcFields>, root: HTMLElement): void {
		(root as JSrcFieldsPointer)._srcFields = row.rowDatas;
		let span = root.firstElementChild as HTMLElement;
		if (!span) span = this._buildContent(row, root);
		const icon = this._getIcon(row);
		const label = this._getValue(row);
		if (icon) {
			span.style.unicodeBidi = 'isolate';
			span.style.backgroundImage = icon.startsWith('--') ? `var(${icon})` : `url("${icon}")`;
		} else {
			span.style.backgroundImage = 'none';
		}
		span = span.nextElementSibling as HTMLElement;
		DOM.setTextContent(span, this._getTitle(row) || label);
	}


	protected _buildContent(row: IGridDataRow, root: HTMLElement): HTMLElement {
		this._addTooltip(root);
		const span = document.createElement('span');
		span.setAttribute("class", "icon");
		let st = span.style;
		st.paddingLeft = this.iconWidth;
		(st as any).marginInlineEnd = this.iconLabelGap;
		if (this.iconFilter) st.filter = this.iconFilter;
		root.appendChild(span);
		//title
		st = root.appendChild(document.createElement('span')).style;
		(st as any).marginInlineStart = this.iconLabelGap;
		return span;
	}

	protected _getTitle(row: GridDataRowJson<JSrcFields>) {
		return this.srcRdr.getSecondName(row.rowDatas, this.wspMetaUi) || "";
	}

	fillSearchColumns(map: Map<string, string | ISearchFunc>) {
		super.fillSearchColumns(map);
		map.set('itTi', null);
	}

}

/**
 * Cellule affichant l'espace de l'item
 */
export class CellBuilderSpace extends CellBuilderString {

	constructor() {
		super('srcUri');
	}

	protected _getValue(row: IGridDataRow): any {
		const srcUri = row.getData(this.dataKey) as string;
		if (!srcUri) return "";
		if (ITEM.isAirItem(srcUri)) return "[Item flottant]";
		if (ITEM.isExtItem(srcUri)) return "[Item étranger]";
		const idx = srcUri.indexOf(".");
		if (idx < 0) return srcUri.substring(1);
		const idx2 = srcUri.lastIndexOf("/", idx);
		return idx2 > 0 ? srcUri.substring(1, idx2) : "";
	}
}

/**
 * CellBuilder qui n'affiche que l'icone du type d'item et son title en tooltip.
 * Permet de trier une liste selon le type d'items.
 */
export class CellBuilderItModelFlagIcon extends CellBuilderFlagIcon {
	protected srcRdr: ISrcRenderer;

	constructor(reg: IReg<any>, public wspMetaUi: WspMetaUi) {
		super('itModel' as ESrcField);
		this.srcRdr = reg.getSvc(ITEM.KEY_SrcRenderer);
	}

	protected _getValue(row: GridDataRowJson<JSrcFields>): any {
		return this.wspMetaUi.getItemType(row.rowDatas.itModel).getTitle();
	}

	protected _getIcon(row: GridDataRowJson<JSrcFields>): string {
		return row.cacheHolder['icon'] || (row.cacheHolder['icon'] = this.srcRdr.getIcon(row.rowDatas, this.wspMetaUi));
	}
}

/**
 * CellBuilder qui n'affiche que l'icone du type d'item et son title en tooltip.
 * Permet de trier une liste selon le type d'items.
 */
export class CellBuilderItModel extends CellBuilderLabel {
	protected srcRdr: ISrcRenderer;

	constructor(reg: IReg<any>, public wspMetaUi: WspMetaUi) {
		super('itModel' as ESrcField);
		this.srcRdr = reg.getSvc(ITEM.KEY_SrcRenderer);
	}

	protected _getValue(row: GridDataRowJson<JSrcFields>): any {
		return this.wspMetaUi.getItemType(row.rowDatas.itModel).getTitle();
	}

	protected _getIcon(row: GridDataRowJson<JSrcFields>): string {
		return row.cacheHolder['icon'] || (row.cacheHolder['icon'] = this.srcRdr.getIcon(row.rowDatas, this.wspMetaUi));
	}
}

/**
 * CellBuilder pour les resps : liste des utilisateur d'une resp donnée
 */
export class CellBuilderResp extends CellBuilderAccount {

	constructor(public respCode: string, protected reg: IReg<ICoreUniverseEnv>, dataKey: string, public hideIcon: boolean = false) {
		super(reg, dataKey, hideIcon)
	}

	getAccount(row: GridDataRowJsonTree<any>): string {
		const src = row.rowDatas;
		if (!src[this.dataKey]) return null;
		//const itemType = this.wspMetaUi.getItemType(src.itModel);
		const resps = RESPS.toRespsList(src[this.dataKey]);
		return resps[this.respCode] ? resps[this.respCode][0] : null;
	}
}

export class CellBuilderResps extends CellBuilderAccounts {

	constructor(public respCode: string, protected reg: IReg<ICoreUniverseEnv>, dataKey: string, public hideIcon: boolean = false) {
		super(reg, dataKey, hideIcon)
	}

	getAccounts(row: GridDataRowJsonTree<any>): string[] {
		const src = row.rowDatas;
		if (!src[this.dataKey]) return null;
		//const itemType = this.wspMetaUi.getItemType(src.itModel);
		const resps = RESPS.toRespsList(src[this.dataKey]);
		return resps[this.respCode];
	}
}

/**
 * CellBuilder pour les cycles de vie (items et tasks)  : afficage de l'icone et de l'état
 */
export class CellBuilderLc extends CellBuilderIconLabel {

	constructor(public wspMetaUi: WspMetaUi) {
		super("lcSt");
	}

	protected _getValue(row: GridDataRowJson<JSrcFields>): any {
		const src = row.rowDatas;
		if (!src.lcSt) return null;
		const itemType = this.wspMetaUi.getItemType(src.itModel);
		const lcProv: ILcProvider = itemType instanceof ItemTypeTask ? itemType : this.wspMetaUi;
		const lc = lcProv.getLcStateOrUnknown(src.lcSt);
		return lc ? lc.name : "";
	}

	protected _getIcon(row: GridDataRowJson<JSrcFields>): string {
		const src = row.rowDatas;
		if (!src.lcSt) return null;
		const itemType = this.wspMetaUi.getItemType(src.itModel);
		const lcProv: ILcProvider = itemType instanceof ItemTypeTask ? itemType : this.wspMetaUi;
		const lc = lcProv.getLcStateOrUnknown(src.lcSt);
		return lc ? lc.iconUrl : "";
	}
}

/**
 * CellBuilder pour les cycles de vie (items et tasks) : affichage de l'icone uniquement
 */
export class CellBuilderLcFlag extends CellBuilderFlagIcon {

	constructor(public wspMetaUi: WspMetaUi) {
		super("lcSt");
		this.setIconWidth(".8rem");
	}

	protected _getIcon(row: GridDataRowJson<any>): string {
		const lcSt = row.getData("lcSt" as ESrcField);
		if (!lcSt) return null;
		const itemType = this.wspMetaUi.getItemType(row.getData("itModel" as ESrcField));
		const lcProv: ILcProvider = itemType instanceof ItemTypeTask ? itemType : this.wspMetaUi;
		const lc = lcProv.getLcStateOrUnknown(lcSt);
		return lc ? lc.iconUrl : "";
	}

	protected _getValue(row: GridDataRowJson<any>): any {
		const lcSt = row.getData("lcSt" as ESrcField);
		if (!lcSt) return null;
		const itemType = this.wspMetaUi.getItemType(row.getData("itModel" as ESrcField));
		const lcProv: ILcProvider = itemType instanceof ItemTypeTask ? itemType : this.wspMetaUi;
		const lc = lcProv.getLcStateOrUnknown(lcSt);
		return lc ? lc.name : "";
	}
}


/** CellBuilder pour la deadLine des tasks */
export class CellBuilderTkDeadline extends CellBuilderDate {

	// @ts-ignore
	get defaultSortValue() {return Date.now()}

	constructor() {
		super("tkDeadline" as ESrcField);
	}
}

/** CellBuilder pour la scheduledDt des tasks */
export class CellBuilderTkScheduledD extends CellBuilderDate {

	// @ts-ignore
	get defaultSortValue() {return Date.now()}

	constructor() {
		super("tkScheduledDt" as ESrcField);
	}
}


/**
 * function commune pour redessiner les lignes en fonction du contexte.
 */
export function redrawSrcLine(wsp: Wsp, src: JSrcFields, line: HTMLElement, currentSrcUri: string | null, highlightSgn: RegExp | null, assigned: srcRef | null): void {
	line.classList.toggle('current', src.srcUri === currentSrcUri);
	if (highlightSgn) {
		if (assigned && (assigned === src.srcId || assigned === src.srcUri)) {
			line.classList.toggle('assigned', true);
			line.classList.toggle('highlight', false);
		} else {
			const sgn = src.itSgn;
			line.classList.toggle('highlight', sgn ? highlightSgn.test(sgn) : false);
			line.classList.toggle('assigned', false);
		}
	} else {
		line.classList.toggle('highlight', false);
		line.classList.toggle('assigned', false);
	}
	const wspMetaUi = wsp.wspMetaUi;
	if (wspMetaUi) {
		if (wspMetaUi.getLcStates() !== null) {
			//Wsp avec liveCycle sur les items.
			DOM.setStyle(line, "color", src.lcSt != null ? wspMetaUi.getLcStateOrUnknown(src.lcSt).color || "" : "");
		}
		if (wspMetaUi.flagItemsWithTasks) {
			DOM.setStyle(line, "font-weight", src.tkPending ? 'bold' : null);
		}
	}
}